module.exports = __webpack_public_path__ + "canny-slack-integration-6f69e3528ae992ad56fa3dd42ec31a62.png";